import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { WestnetzSidenavService } from '../../service/common/westnetz-sidenav/westnetz-sidenav.service';
import { take, takeWhile } from 'rxjs/operators';
import { DienstleistungsModuleBeschreibung } from '../../domain/model/dienstleistungsmodulebeschreibung.model';
import { DienstleistungsmoduleService } from '../../service/dienstleistungsmodule/dienstleistungsmodule.service';
import {
    SettingsDienstleistungsmoduleDetailComponent,
} from '../settings-dienstleistungsmodule-detail/settings-dienstleistungsmodule-detail.component';

@Component({
    selector: 'redispatch-settings-dienstleistungsmodule',
    templateUrl: './settings-dienstleistungsmodule-page.component.html',
    styleUrls: [
        './settings-dienstleistungsmodule-page.component.scss',
    ],
    standalone: false,
})
export class SettingsDienstleistungsmodulePageComponent implements OnInit, OnDestroy {

    public dienstleistungsmoduleList = new MatTableDataSource<DienstleistungsModuleBeschreibung>();
    public componentDestroyed = false;

    private datasourceFilter = ((data: DienstleistungsModuleBeschreibung, filter: string) => {
        if (!filter) {
            return true;
        }
        filter = filter.toLowerCase();
        return (
            data.title.toLowerCase().indexOf(filter) !== -1 ||
            data.dienstleistungsmodule.toLowerCase().indexOf(filter) !== -1
        );
    });

    public westnetzSidenavService = inject(WestnetzSidenavService);
    private dienstleistungsmoduleService = inject(DienstleistungsmoduleService);
    private router = inject(Router);
    private changeDetectorRef = inject(ChangeDetectorRef);

    public columnsToDisplay = [
        'dienstleistungsmodule',
        'title',
    ];

    ngOnInit() {
        this.dienstleistungsmoduleList.filterPredicate = this.datasourceFilter;

        this.reloadData();
        this.westnetzSidenavService.closeRightnav$
            .pipe(takeWhile(() => !this.componentDestroyed))
            .subscribe(() => {
                this.reloadData();
            });
    }

    ngOnDestroy(): void {
        this.componentDestroyed = true;
    }

    private reloadData() {
        this.dienstleistungsmoduleService.listDienstleistungsModuleBeschreibung()
            .pipe(take(1))
            .subscribe(kb => {
                this.dienstleistungsmoduleList.data = kb;
                this.changeDetectorRef.markForCheck();
            });
    }

    public applyFilter(event: Event) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dienstleistungsmoduleList.filter = filterValue.trim().toLowerCase();
    }

    public openDienstleistungsModule(module: DienstleistungsModuleBeschreibung) {
        this.router.navigate([],
            {
                queryParams: { module: module.id },
                queryParamsHandling: 'merge',
                skipLocationChange: true,
            });
        this.westnetzSidenavService.openRightnav(SettingsDienstleistungsmoduleDetailComponent);
    }
}
